module.exports = __webpack_public_path__ + "static/img/ppt.7a90fddd.png";